
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'
import PropertyMultiselect from '@/components/PropertyMultiselect.vue'
import HelperTooltip from '@/components/HelperTooltip.vue'

export default Vue.extend({
  components: {
    PropertyMultiselect,
    HelperTooltip
  },

  computed: {
    ...mapFields([
      'roomsData',
      'projectData.hasPro',
      'projectData.hasWhIm',
      'projectData.mixPoints',
      'projectData.hasPro2',
      'projectData.whEymixL',
      'projectData.hasWatts',
      'projectData.hasRpDct',
      'projectData.hasWhEymix'
    ]),

    numberOfEymixLs () {
      const maxNumber = 3 + Math.floor((Math.max(0, (this as any).roomsData.length - 1)) / 10)  // eslint-disable-line

      const options = Array(maxNumber + 1).fill(0).map((val, i) => i)

      return options
    }
  },

  watch: {
    hasPro (next) {
      if (next) {
        (this as any).hasPro2 = false // eslint-disable-line
      }
    },

    hasPro2 (next) {
      if (next) {
        (this as any).hasPro = false // eslint-disable-line
      }
    }
  }
})
